import {Inspection} from "./Inspection";
import InspectionElement from "./InspectionElement";
import {AssetType} from "./AssetType";

export interface ReUseAsset {
    inspection_report_id: string;
    asset_id: string;
    inspection_id: string;
    survey_element_id: number;
    org_id: number;
    imo: string;
    expiry_date: string | null;
}

export const formatDate = (epochValue: number) => {
    const date = new Date(Number(epochValue));
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    if (isNaN(date.getTime())) {
        return null;
    }
    return `${year}-${month}-${day}`;
};


export const getReUseSectionsWithInvalidDates = (inspection: Inspection)  => {
    const inspectionDate = new Date(inspection.InspectionStart)
    const fiveYearsLater = new Date(inspectionDate);
    fiveYearsLater.setFullYear(inspectionDate.getFullYear() + 5);

    return  inspection.sections.flatMap((section) => {
        if(section.ReUseDocuments &&
            section.ElementType === AssetType.Document &&
            section.Documents &&
            section.Documents.length != 0){

            if(!section.expiryDate || isNaN(section.expiryDate)){
                return section.Name +' - No expiry';
            }

            const expiryDate = new Date(Number(section.expiryDate));

            if (expiryDate > fiveYearsLater) {
                return section.Name + ' - expiry : ' + expiryDate.toLocaleDateString();
            }

            return [];
        }
        return [];
    });
};

export const getValidReUseAssets = (inspection: Inspection, elements: InspectionElement[]) => {
    return getReUseAssets(inspection,elements,true);
}

export const getNonValidReUseAssets = (inspection: Inspection, elements: InspectionElement[]) => {
    return getReUseAssets(inspection,elements,false);
}

export const getAllAssets = (inspection: Inspection, elements: InspectionElement[]) => {
    const valid = getValidReUseAssets(inspection,elements);
    const invalid = getNonValidReUseAssets(inspection,elements)
    return valid.concat(invalid);
}



export const getReUseAssets = (inspection: Inspection, elements: InspectionElement[],validForReuse : boolean) => {
    return elements.flatMap((element) => {
        if(element.ValidForReuse == validForReuse) {
            const documents = element.Documents.map((doc) => {
                return {
                    inspection_report_id: element.Id,
                    asset_id: doc.id,
                    inspection_id: inspection.Id,
                    survey_element_id: element.SurveyElementId,
                    org_id: inspection.OrganizationId,
                    expiry_date: element.expiryDate ? formatDate(element.expiryDate as number) : null,
                    vessel_name: inspection.ShipName,
                    imo: inspection.ShipIMO
                } as ReUseAsset;
            });

            return documents.filter((value, index, self) =>
                    index === self.findIndex((t) => (

                        t.inspection_report_id === value.inspection_report_id && t.asset_id === value.asset_id
                    ))
            )
        }
        else {
            return []
        }
    })
}